export default class SubscriberFormBuilderCtrl {
    constructor($scope, $q, $state, $filter, SideMenu, Customization, SubscriberForm, $stateParams, Language, Events) {
        SideMenu.setActive("subscriber");

        this._translator = $filter('translate');
        this._stateParams = $stateParams;
        this._state = $state;
        this._q = $q;
        this._scope = $scope;

        this.subscriberFormRepo = SubscriberForm;
        this.customRepo = Customization;
        this.eventHandler = Events;

        this.status = 'builder';
        this.subscriberForm = {
            fields: [ {
                field_identifier: 'rule_email',
                label: this._translator('GLOBAL:EMAIL'),
                field_type: 'email',
                required: true,
                editable: false
            } ],
            recaptcha: false,
            confirmation: {
                text: '',
                link: {
                    url: '',
                    description: ''
                }
            }
        };

        this.customRepo.allGroups().then((groups) => {
            this.groups = [ {
                field_identifier: 'phone_number',
                fieldName: this._translator('GLOBAL:PHONE_NUMBER'),
                fieldId: 0,
                custom_field_type_id: 1
            } ];

            _.each(groups.data, (group) => {
                _.each(group.fields, (field) => {
                    this.groups.push({
                        groupName: group.name,
                        groupId: group.id,
                        fieldName: field.name,
                        fieldId: field.id,
                        custom_field_type_id: this.fieldTypeNameToId(field.type)
                    })
                })
            })
        });

        Language.all().then((result) => {
            this.languages = result.languages;
        });

        if (this._stateParams.id) {
            this.subscriberFormRepo.find($stateParams.id, [ 'tags', 'fields', 'email', 'language' ]).then((subscriberForm) => {
                this.subscriberForm = subscriberForm.data;
                this.subscriberForm.language_id = subscriberForm.data.language.id;
                this.subscriberForm.recaptcha = !!subscriberForm.data.recaptcha;
                this.loadedTags = subscriberForm.data.tags;
                this.tagIds = [];

                angular.forEach(this.subscriberForm.tags, (tag) => {
                    this.tagIds.push(tag.id);
                });
            });
        } else {
            this.subscriberFormRepo.all().then(response => {
                let allSubscriberFormsLabels = response.data.map(subscriberForm => subscriberForm.label);
                this.subscriberForm.label = $filter('getNumberedName')(allSubscriberFormsLabels, 'New');
            });
        }

        this._scope.$on('subscriberForm:goTo', (event, toState) => {
            return this.goTo(toState);
        });

        this._scope.$on('account:changed', () => {
            this._state.go('subscriberForm.index');
        });
    }

    fieldTypeNameToId(name) {
        let nameToIdMap = {
            'text': 1,
            'single': 2,
            'multiple': 3,
            'json': 4,
            'datetime': 5,
            'date': 6,
            'time': 7
        };

        return nameToIdMap[name] ? nameToIdMap[name] : 1;
    }

    goTo(page) {
        this.save().then(() => {
            if (this._stateParams.id && page == 'email') {
                if (this.subscriberForm.email) {
                    this._state.go('subscriberForm.email.edit', {
                        id: this._stateParams.id,
                        emailId: this.subscriberForm.email.id
                    });
                } else {
                    this._state.go('subscriberForm.email', { id: this._stateParams.id });
                }
            } else if (this._stateParams.id && page != 'email') {
                this._state.go('subscriberForm.' + page, { id: this._stateParams.id });
            }
        });
    };

    save(page) {
        let deferred = this._q.defer();

        if (!this.subscriberForm.tags || this.subscriberForm.tags.length < 1) {
            this.eventHandler.flashEvent('error', this._translator('SUBSCRIBER_FORM:BUILDER:NO_TAGS'));
            deferred.reject();

            return deferred.promise;
        }

        let subscriberForm = {
            label: this.subscriberForm.label,
            tags: this.subscriberForm.tags,
            fields: this.subscriberForm.fields,
            recaptcha: this.subscriberForm.recaptcha,
            language: this.subscriberForm.language_id,
            confirmation: this.subscriberForm.confirmation
        };

        if (!this._stateParams.id) {
            this.subscriberFormRepo.create(subscriberForm).then((subscriberForm) => {
                let toState = page == 'email' ? 'subscriberForm.email' : 'subscriberForm.edit';
                this._state.go(toState, { id: subscriberForm.data.id });
                deferred.resolve();
            }, (error) => {
                let errorMessage = this._translator('SUBSCRIBER_FORM:BUILDER:SAVE_ERROR');
                if (error.data && error.data.code === 9) {
                    errorMessage = error.data.message || errorMessage;
                }
                this.eventHandler.flashEvent('error', errorMessage);
                deferred.reject();
            });
        } else {
            this.subscriberFormRepo.update(this._stateParams.id, subscriberForm).then((response) => {
                this.subscriberForm.fields = response.data.fields;
                deferred.resolve();
            }, (error) => {
                this.eventHandler.flashEvent('error', this._translator('SUBSCRIBER_FORM:BUILDER:SAVE_ERROR'));
                deferred.reject();
            });
        }

        return deferred.promise;
    };

    updateSubscriberFormFieldName(data, index) {
        this.subscriberForm.fields[index].name = data;
    };

    removeField(index, field) {
        this.subscriberForm.fields.splice(index, 1);

        if (field.id) {
            this.subscriberFormRepo.removeField(this.subscriberForm, field.id).then(() => {
                // Do nothing..
            }, () => {
                this.eventHandler.flashEvent('error', 'Det gick inte att ta bort fältet!');
            });
        } else {
            this.subscriberForm.fields.splice(index, 1)
        }
    };

    isFieldUnique(field) {
        let isUnique = true;

        _.each(this.subscriberForm.fields, (subscriberFormElement) => {
            if (subscriberFormElement.field_identifier == field.field_identifier) {
                isUnique = false
            }
        });

        return isUnique;
    };

    addField(item, model) {
        if (!item.field_identifier) {
            item.field_identifier = item.groupName + '.' + item.fieldName
        }

        if (this.isFieldUnique(item)) {
            this.subscriberForm.fields.push({
                field_identifier: item.field_identifier,
                label: item.fieldName,
                custom_field_type_id: item.custom_field_type_id,
                required: false,
                editable: true
            });
        }
    }
};
